import { abstractHooks } from '@openobserve/browser-core';
export const createHooks = (abstractHooks);
//# sourceMappingURL=hooks.js.map